import { render, staticRenderFns } from "./dealer.vue?vue&type=template&id=2abc01f2&"
import script from "./dealer.vue?vue&type=script&lang=ts&"
export * from "./dealer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports